import { ICartItemCurrency } from '@helpers/arToysHelpers'
import { product } from '@specs/specs'

export namespace cartFeature {
    export const COOKIES = {
        cartItems: 'cartItems',
        cartCurrencyItems: 'cartCurrencyItems',
        couponInCart: 'couponInCart'
    }

    export const ProductMapper = {
        toPrisma: (item: ICartItemCurrency): product => ({
            id: item.productId,
            currentPrice: item.price,
            toyid: item.toyId || null,
            toyExpires: item.toyExpires,
            goldAmount: item.variant === 'gold' ? item.amount : null,
            ruby: item.variant === 'ruby' ? item.amount : null,
            plan: null,
            imageId: item.imageId,
            visible: false,
            recommended: false,
            isWelcome: false,
            priority: 0,
            pass: 'currentSeason'
        }),

        toViewModel: (item: product): ICartItemCurrency => ({
            productId: item.id,
            toyId: item.toyid || null,
            toyExpires: item.toyExpires || null,
            variant: item.goldAmount ? 'gold' : 'ruby',
            price: item.currentPrice,
            amount: item.goldAmount || item.ruby,
            amountOfProducts: 1,
            imageId: item.imageId
        })
    }
}

export const createProductsQuery = (products: Array<product & { productAmount?: number }>) =>
    products.map((p) => `${p.id}:${p.productAmount || 1}`).join(',')

export const parseProductsQuery = (query: string) => {
    const productsWithQuantity = decodeURI(query).split(',')
    return productsWithQuantity.map((p) => {
        const [id, quantity] = p.split(':')
        return { id: Number(id), quantity: Number(quantity) }
    })
}
